(function () {
  const initProductAccordion = () => {
    const toggles = document.querySelectorAll(".about__accordion-toggle");

    toggles.forEach((toggle) => {
      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        const description = toggle.nextElementSibling?.classList.contains(
          "about__accordion-description"
        )
          ? toggle.nextElementSibling
          : toggle.previousElementSibling?.classList.contains(
              "about__accordion-description"
            )
          ? toggle.previousElementSibling
          : null;

        if (description) {
          if (!toggle.classList.contains("active")) {
            slideDown(toggle, description, 300); // func in global.js
          } else {
            slideUp(toggle, description, 300); // func in global.js
          }
        }
      });
    });
  };

  let countdownInterval;

  const initProductCountdown = () => {
    const countDownWrapper = document.querySelector(".product-countdown");
    if (!countDownWrapper) return;

    const userDate = countDownWrapper.getAttribute("data-date");
    const userTime = countDownWrapper.getAttribute("data-time");

    removeProductCountdown();

    countdownInterval = setInterval(
      () => updateTimer(countDownWrapper, userDate, userTime),
      1000
    );

    updateTimer(countDownWrapper, userDate, userTime);
  };

  const removeProductCountdown = () => {
    clearInterval(countdownInterval);
  };

  const updateTimer = (wrapper, userDate, userTime) => {
    const completedCountdown = wrapper.getAttribute("data-completed");
    const countdown = wrapper.querySelector(".product-countdown__main");
    const countdownHeading =
      wrapper.querySelector(".product-countdown__end-info") || null;
    const countdownPromo =
      wrapper.querySelector(".product-countdown__promo") || null;

    const countdownDate = new Date(`${userDate}T${userTime}`);
    const now = new Date();
    const distance = countdownDate - now;

    if (distance < 0) {
      removeProductCountdown();
      handleCountdownEnd(
        wrapper,
        countdown,
        countdownHeading,
        completedCountdown,
        countdownPromo
      );
    } else {
      displayTime(wrapper, distance);
    }
  };

  const handleCountdownEnd = (
    wrapper,
    countdown,
    countdownHeading,
    completedCountdown,
    countdownPromo
  ) => {
    if (completedCountdown === "hide_section") {
      wrapper.style.display = "none";
    } else if (completedCountdown === "show_text") {
      countdown.style.display = "none";
      if (countdownPromo) countdownPromo.style.display = "none";
      if (countdownHeading) countdownHeading.style.display = "flex";
    }
  };

  const displayTime = (wrapper, distance) => {
    const daysEl = wrapper.querySelector(".product-countdown_block_days");
    const hoursEl = wrapper.querySelector(".product-countdown_block_hours");
    const minutesEl = wrapper.querySelector(".product-countdown_block_minutes");
    const secondsEl = wrapper.querySelector(".product-countdown_block_seconds");

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    daysEl.textContent = formatTime(days);
    hoursEl.textContent = formatTime(hours);
    minutesEl.textContent = formatTime(minutes);
    secondsEl.textContent = formatTime(seconds);
  };

  const formatTime = (time) => (time < 10 ? `0${time}` : time);

  const revealPopup = () => {
    const productSection = document.querySelector(".product-section");
    const stickyBar = document.querySelector(".product-countdown");
    const footer = document.querySelector(
      ".shopify-section-group-footer-group"
    );

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.01,
    };

    const toggleStickyBar = (isVisible) => {
      if (isVisible) {
        stickyBar.classList.remove("active");
        removeProductCountdown();
      } else {
        stickyBar.classList.add("active");
        initProductCountdown();
      }
    };

    const handleIntersect = (entries, observer) => {
      const isVisible = entries.some((entry) => entry.isIntersecting);
      toggleStickyBar(isVisible);
    };

    if (!stickyBar) return;

    const observer = new IntersectionObserver(handleIntersect, observerOptions);

    if (productSection) observer.observe(productSection);
    if (footer) observer.observe(footer);
  };

  document.addEventListener("shopify:section:load", () => {
    initProductAccordion();
    revealPopup();
  });

  initProductAccordion();
  revealPopup();
})();

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.shopify_subscriptions_app_container');
  if (!container) return;

  const oneTimeInput = container.querySelector('input[data-radio-type="one_time_purchase"]');
  const subInput = container.querySelector('input[data-radio-type="selling_plan"]');
  const oneTimeCard = oneTimeInput?.closest('.group_list_item');
  const subCard = subInput?.closest('.group_list_item');
  const qty =
    document.querySelector('.product-form__quantity input.quantity__input') ||
    document.querySelector('.quantity__input') ||
    document.querySelector('.quantity input');
  const qtyWrapper =
    document.querySelector('.product-form__quantity') ||
    document.querySelector('.quantity')?.closest('.product-form__input') ||
    document.querySelector('.quantity');
  const benefits = document.querySelector('.custom-subscription-benefits');

  const oneTimePerDay = document.querySelector('.one-time-per-day')?.textContent.trim();
  const subPerDay = document.querySelector('.subscription-per-day')?.textContent.trim();
  const bannerText = document.querySelector('.subscription-banner-text')?.textContent.trim();

  if (!oneTimeCard || !subCard || !qtyWrapper) return;

  const parsePrice = (value) => {
    if (!value) return 0;
    return parseFloat(value.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
  };

  const formatPrice = (value) => {
    return `€${value.toFixed(2).replace('.', ',')}`;
  };

  const unitOneTimePrice = parsePrice(oneTimeInput?.dataset.variantPrice);
  const unitSubPrice = parsePrice(subInput?.dataset.variantPrice);
  const unitComparePrice = parsePrice(subInput?.dataset.variantCompareAtPrice);

  const ensureHolder = (card) => {
    let holder = card.querySelector('.subscription-qty-holder');
    if (!holder) {
      holder = document.createElement('div');
      holder.className = 'subscription-qty-holder';
      card.appendChild(holder);
    }
    return holder;
  };

  const getPriceEl = (card) => card?.querySelector('.in_widget_price');

  const renameOneTime = () => {
    const wrapper = oneTimeCard.querySelector('.in_widget_price')?.parentElement;
    if (!wrapper) return;
    const textNode = [...wrapper.childNodes].find(
      (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
    );
    if (textNode) textNode.textContent = 'Einmalige Lieferung';
  };

  const overrideSubscriptionLabel = () => {
    const label = subCard?.querySelector('span');
    if (label) label.textContent = 'Monatlicher Sparplan';
  };

  const addBanner = () => {
    const list = container.querySelector('.group_list');
    if (!list || container.querySelector('.custom-subscription-banner')) return;

    const banner = document.createElement('div');
    banner.className = 'custom-subscription-banner';
    banner.textContent = bannerText || 'Sparen Sie jeden Monat!';
    list.parentNode.insertBefore(banner, list);
  };

  const ensurePerDay = (priceEl, text) => {
    if (!priceEl || !text) return null;
    let el = priceEl.querySelector('.price-per-day');
    if (!el) {
      el = document.createElement('span');
      el.className = 'price-per-day';
      priceEl.appendChild(el);
    }
    el.textContent = `| ${text}`;
    return el;
  };

  const ensureOldPrice = () => {
    let oldPrice = subCard.querySelector('.subscription-old-price');
    if (!oldPrice) {
      oldPrice = document.createElement('div');
      oldPrice.className = 'subscription-old-price';
      getPriceEl(subCard)?.insertAdjacentElement('afterend', oldPrice);
    }
    return oldPrice;
  };

  const updateDisplayedPrices = () => {
    const quantity = Math.max(parseInt(qty?.value || '1', 10), 1);
    const selected = container.querySelector('input[type="radio"][name^="purchaseOption_"]:checked');
    if (!selected) return;

    const oneTimePriceEl = getPriceEl(oneTimeCard);
    const subPriceEl = getPriceEl(subCard);
    const oldPriceEl = ensureOldPrice();

    if (selected.dataset.radioType === 'one_time_purchase') {
      if (oneTimePriceEl) {
        oneTimePriceEl.innerHTML = `${formatPrice(unitOneTimePrice * quantity)}`;
        ensurePerDay(oneTimePriceEl, oneTimePerDay);
      }

      if (subPriceEl) {
        subPriceEl.innerHTML = `${formatPrice(unitSubPrice)}`;
        ensurePerDay(subPriceEl, subPerDay);
      }

      if (oldPriceEl) {
        oldPriceEl.textContent = `${formatPrice(unitComparePrice)}${oneTimePerDay ? ` | ${oneTimePerDay}` : ''}`;
      }
    }

    if (selected.dataset.radioType === 'selling_plan') {
      if (oneTimePriceEl) {
        oneTimePriceEl.innerHTML = `${formatPrice(unitOneTimePrice)}`;
        ensurePerDay(oneTimePriceEl, oneTimePerDay);
      }

      if (subPriceEl) {
        subPriceEl.innerHTML = `${formatPrice(unitSubPrice * quantity)}`;
        ensurePerDay(subPriceEl, subPerDay);
      }

      if (oldPriceEl) {
        oldPriceEl.textContent = `${formatPrice(unitComparePrice * quantity)}${oneTimePerDay ? ` | ${oneTimePerDay}` : ''}`;
      }
    }
  };

  const updateUI = () => {
    const selected = container.querySelector('input[type="radio"][name^="purchaseOption_"]:checked');
    if (!selected) return;

    const isSub = selected.dataset.radioType === 'selling_plan';
    ensureHolder(isSub ? subCard : oneTimeCard).appendChild(qtyWrapper);

    if (benefits) {
      subCard.insertAdjacentElement('afterend', benefits);
      benefits.hidden = false;
      benefits.style.display = 'block'; // Forces it to show always, even if not selected
      benefits.classList.toggle('is-selected', isSub);

      // --- UPDATED: Add the Modal Trigger Link ---
      // Removed the 'if (isSub)' check so this always renders on page load
      let modalTriggerWrapper = benefits.querySelector('.eykaer-abo-modal-wrapper');
      
      // Only create it if it doesn't already exist
      if (!modalTriggerWrapper) {
        modalTriggerWrapper = document.createElement('div');
        modalTriggerWrapper.className = 'eykaer-abo-modal-wrapper';
        
        // Construct the sentence with an inline button
        modalTriggerWrapper.innerHTML = `Mehr Details zum Sparplan finden Sie <button class="eykaer-abo-modal-trigger" type="button">hier</button>.`;
        
        // Append it to the bottom of the benefits block
        benefits.appendChild(modalTriggerWrapper);

        // Add the click event to open the modal
        const modalTrigger = modalTriggerWrapper.querySelector('.eykaer-abo-modal-trigger');
        modalTrigger.addEventListener('click', (e) => {
          e.preventDefault();
          const modal = document.getElementById('eykaer-abo-modal');
          if(modal) {
            modal.classList.add('is-open');
            document.body.style.overflow = 'hidden'; // Stop background scrolling
          }
        });
      }
    }
  };

  renameOneTime();
  overrideSubscriptionLabel();
  addBanner();
  updateUI();
  updateDisplayedPrices();

  container.addEventListener('change', (e) => {
    if (!e.target.matches('input[type="radio"][name^="purchaseOption_"]')) return;

    if (qty) {
      qty.value = 1;
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateUI();
    updateDisplayedPrices();
  });

  qty?.addEventListener('input', updateDisplayedPrices);
  qty?.addEventListener('change', updateDisplayedPrices);

  document.addEventListener('click', (e) => {
    if (e.target.closest('.quantity__button')) {
      setTimeout(updateDisplayedPrices, 0);
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('eykaer-abo-modal');
  const closeBtn = document.getElementById('close-eykaer-modal');

  if(modal) {
    const openModal = () => {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden'; // Stop background scrolling
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    // Close when clicking outside the white box
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

    // --- NEW: Intercept the click BEFORE the subscription app sees it ---
    document.addEventListener('click', (e) => {
      // Look for the specific ID the app generates
      const policyBtn = e.target.closest('#shopify-subscription-policy-button');
      
      if (policyBtn) {
        e.preventDefault();              // Stop normal link behavior
        e.stopPropagation();             // Stop event from bubbling up
        e.stopImmediatePropagation();    // BLOCKS the subscription app's default modal
        
        openModal();                     // Open OUR modal instead
      }
    }, true); // The 'true' here is the magic key. It forces this listener to run first.
  }
});
